import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Moment from "react-moment";
import EditComment from "./EditComment";
import Avatar from "../../shared/commonComponents/Avatar";
import { OverlayTrigger, Popover } from "react-bootstrap";
import authSlice from "../../store/auth/authSlice";

function ChildComment(props) {
    const dispatch = useDispatch();
    const [showLikesButton, setShowLikesButton] = useState(false);
    const loggedInUser = useSelector((state) => state.auth.loggedInUser);
    const openProfile = (userId, offeringUserId) => {
        dispatch(
            authSlice.actions.setProfileData({
                userId: userId,
                offeringUserId: offeringUserId,
            })
        );
        dispatch(
            authSlice.actions.setProfileStack({
                userId: userId,
                offeringUserId: offeringUserId,
            })
        );
        dispatch(authSlice.actions.setProfileLoader({ showLoader: true }));
        dispatch(authSlice.actions.showProfile());
        setTimeout(function () {
            dispatch(authSlice.actions.setProfileLoader({ showLoader: false }));
        }, 2000);
    };

    useEffect(() => {
        if (parseInt(props.userProfile.offeringUserId) == parseInt(loggedInUser.offeringUserId)) {
            if (props.likes > 0) {
                setShowLikesButton(true);
            }
        } else {
            setShowLikesButton(true);
        }
    }, []);

    const popover = (
        <Popover id="popover-basic" className="profilePopover">
            <div className="popover-profile-top-section">
                {/* <div className="profile-picture">
              <div className="profile-avatar">
              <UserThumbnail currentUser={true} className="profile-avatar" />
              </div>
            </div> */}
                <Avatar {...props.userProfile} className="small" />
                <div className="profile-details">
                    <div className="profile-name">
                        {props.userProfile.firstName + " " + props.userProfile.lastName}
                    </div>
                    <div className="profile-teamname">{props.userProfile.teamName}</div>
                    <div className="profile-missionname">{props.userProfile.missionName}</div>
                </div>
            </div>
            <div className="popover-profile-bottom-section">
                <div className="profile-email">{props.userProfile.email}</div>
                <div
                    className="profile-view"
                    onClick={() => {
                        openProfile(props.userProfile.id, props.userProfile.offeringUserId);
                    }}
                >
                    View Profile
                </div>
            </div>
        </Popover>
    );
    return (
        <Row
            key={`reply-${props.index}`}
            className="commentusernameRow"
        >
            <Col sm={1} style={{ padding: 0, display: "flex", justifyContent: "center" }}>
                <Avatar {...props.userProfile} className="small" />
            </Col>
            <Col sm={11}>
                <Row className="commentusernameRow commentorusernameDiv">
                    <Col
                        sm={10}
                        className="commentorusernameDiv"
                    >
                        <OverlayTrigger
                            trigger="click"
                            placement="top"
                            overlay={popover}
                            rootClose
                        >
                            <span
                                className="commentorusername"
                            >
                                {props.userProfile.firstName}{" "}
                                {props.userProfile.lastName}
                            </span>
                        </OverlayTrigger>
                        <div className="verticalLine"></div>
                        <span className="commentTime">
                            <Moment
                                parse="YYYY-MM-DD HH:mm"
                                fromNow
                                local={true}
                            >
                                {
                                    new Date(
                                        props.commentedOn + "Z"
                                    )
                                }
                            </Moment>
                        </span>
                    </Col>
                    {showLikesButton &&
                        <Col sm={2} className="commentlikeDiv">
                            <div
                                onClick={() => {
                                    props.handleLikeClick(props);
                                }}
                                className={`thumbsup ${props.isLiked
                                    ? "commentliked"
                                    : "commentnotliked"
                                    }`}
                            ></div>{" "}
                            {props.likes != 0 && (
                                <span>{props.likes}</span>
                            )}
                        </Col>
                    }
                </Row>
                <Row>
                    <Col className="commentdescRow">
                        <EditComment
                            comment={props}
                            commentFrom={props.commentFrom}
                            reloadComments={props.reloadComments}
                            showAssignment={props.parentProps.showAssignment}
                        />

                    </Col>
                </Row>
            </Col>
        </Row>
    );
}

export default ChildComment;